import { fetchTranslate } from '../../../../i18n/i18n'
import { i18n } from '../../../../i18n/i18n';
import { Md5 } from 'ts-md5/dist/md5';
import * as React from 'react';
import style from './TranslationButtons.less';
import { WActionButton } from '../../../../core/elements/WActionButton';

interface TranslationButtonsProps extends React.ClassAttributes<any> {
    data: any;
    isSaving?: (state: boolean) => void;
    locale: string;
    onChange?: (data: any) => void;
    showPreview?: (data: string) => void;
    Translation: any;
}

interface TranslationButtonsState {
    showPreview: boolean;
}

export class TranslationButtons extends React.Component<TranslationButtonsProps, TranslationButtonsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showPreview: false
        };
        this.onClickAutoTranslate = this.onClickAutoTranslate.bind(this);
        this.onClickEdit = this.onClickEdit.bind(this);
        this.onClickVerify = this.onClickVerify.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    public static previews: any = {};

    componentWillUnmount(): void {
        this.reset();
    }

    async getGoogleTranslation(): Promise<string> {
        const { data, locale } = this.props;
        const name: string = data.name || '';
        const id: string = Md5.hashAsciiStr(`[${locale}][${name}]`).toString();
        const preview: any = TranslationButtons.previews[id] || {};

        if (typeof preview.text !== 'undefined') {
            return preview.text;
        }
        return await fetchTranslate(name, locale, (translate: string) => console.info('GOOGLE', name, '->', locale, translate))
    }

    isSaving(state: boolean): void {
        if (typeof this.props.isSaving === 'function') {
            this.props.isSaving(state);
        }
    }

    onChange(data: any): void {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(data);
        }
    }

    async onClickAutoTranslate(): Promise<void> {
        const { data, locale, Translation } = this.props;
        const name: string = data.name || '';
        const text: string = await this.getGoogleTranslation();
        this.isSaving(true);
        this.onChange({ key: name, locale, text });
        data.text = text;
        Translation.setData(data, locale, () => this.isSaving(false));
    }

    async onClickEdit(): Promise<void> {
        const { data, locale, Translation } = this.props;
        const name: string = data.name || '';
        const original: string = (name || '').toString();
        let curText: string = data.isTranslated ? data.text : null;
        let text: string = null;

        do {
            if (curText === null) {
                curText = await this.getGoogleTranslation();
            }
            console.info('EDIT', name, '->', locale, curText, data);
            text = prompt(`"${original}" ${i18n('übersetzen mit', 'sys')}:\n[${locale}]`, curText);

            if (text === null || (text === curText && data.isTranslated)) {
                return;
            } else if (!(text || '').trim().length) {
                alert(i18n('Bitte geben Sie eine Übersetzung ein!', 'sys'));
            }
        } while ((!(text || '').trim().length && text !== null));
        this.isSaving(true);
        this.onChange({ key: name, locale, text });
        data.text = text;
        Translation.setData(data, locale, () => this.isSaving(false));
    }

    onClickVerify(): void {
        const { data, locale, Translation } = this.props;
        const isVerified: boolean = data.isVerified !== 'undefined' ? !data.isVerified : false;
        const name: string = data.name || '';
        this.isSaving(true);
        this.onChange({ key: name, locale, isVerified });
        data.isVerified = isVerified;
        Translation.setData(data, locale, () => this.isSaving(false));
    }

    onMouseEnter(): void {
        const { data, locale } = this.props;
        const name: string = data.name || '';

        if (data.isTranslated) {
            return;
        }
        this.setState({ showPreview: true }, async () => {
            this.showPreview({ key: name, locale, text: await this.getGoogleTranslation() });
        });
    }

    onMouseLeave(): void {
        this.reset();
    }

    render(): JSX.Element {
        const { data } = this.props;

        return (
            <div
                className={style.buttons}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                <WActionButton
                    label={i18n('Übersetzen', 'sys')}
                    tooltip={i18n('Übersetzung anpassen', 'sys')}
                    key='edit'
                    action='edit'
                    style='small'
                    onAction={ this.onClickEdit}
                />
                {!data.isTranslated &&
                    <WActionButton
                        label={i18n('autom. Übersetzen', 'sys')}
                        tooltip={i18n('automatisch Übersetzen', 'sys')}
                        key='auto_translate'
                        action='add'
                        style='small'
                        onAction={this.onClickAutoTranslate}
                    />
                }
                {!!data.isTranslated && !data.isVerified &&
                    <WActionButton
                        label={i18n('Verifizieren', 'sys')}
                        tooltip={i18n('Übersetzung verifizieren', 'sys')}
                        key='verify'
                        action='formSave'
                        style='small'
                        onAction={this.onClickVerify}
                    />
                }
                {!!data.isTranslated && data.isVerified &&
                    <WActionButton
                        label={i18n('Falsifizieren', 'sys')}
                        tooltip={i18n('Übersetzung falsifizieren', 'sys')}
                        key='verify'
                        action='help'
                        style='small'
                        onAction={this.onClickVerify}
                    />
                }
            </div>
        );
    }

    reset() {
        this.setState({ showPreview: false }, () => this.props.showPreview(null));
    }

    showPreview(data: any): void {
        const { key, locale } = data || {};
        const id: string = Md5.hashAsciiStr(`[${locale}][${key}]`).toString();

        if (!TranslationButtons.previews[id]) {
            TranslationButtons.previews[id] = data;
        }

        if (typeof this.props.showPreview === 'function' && this.state.showPreview) {
            this.props.showPreview(id);
        }
    }
}
